var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("direct-to-lender.lenderSubmit.principalBorrower")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.commissionRecordInfo.principalBorrower
          ? _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.commissionRecordInfo.principalBorrower) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("application-form.lender")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " + _vm._s(_vm.commissionRecordInfo.lender) + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("application-form.term")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n      " + _vm._s(_vm.commissionRecordInfo.term) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("application-form.property-address")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.commissionRecordInfo.propertyAddress) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("direct-to-lender.lenderResponse.lenderReferenceNumber")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.commissionRecordInfo.lenderReferenceNumber) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("application-form.net-rate")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " + _vm._s(_vm.commissionRecordInfo.netRate) + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("application-form.loan-type")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " + _vm._s(_vm.commissionRecordInfo.loanType) + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("application-form.funded-amount")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.commissionRecordInfo.fundedAmount) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "4" } }, [
        _c("h6", { staticClass: "form-title font-sm" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("application-form.closing-date")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " + _vm._s(_vm.commissionRecordInfo.closingDate) + "\n    "
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }